import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "A Wrapper with a Button",
description: "Build a custom Svelte wrapper component in Freon that augments a phone number with a clickable button and snackbar notification, and register it for use in projections.",
tags: [ "Freon", "Svelte", "external components", "wrapper", "NumberWrapperBox", "RenderComponent", "PhoneButton", "Flowbite", "CourseSchedule", "projections"] ,
modifiedTime: "2025-11-07T19:14:07.931Z",
publishedTime: "2025-11-07T17:20:18.642Z"
    }
  };
};